const inClient = () => typeof window !== "undefined";

const getStoredItem = (key: string) => (inClient() ? window.localStorage.getItem(key) : null);
const saveStoredItem = (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};
const removeStoredItem = (key: string) => {
  window.localStorage.removeItem(key);
};

class StorageItem {
  readonly key: string;

  constructor(key: string) {
    this.key = key;
  }

  get = () => getStoredItem(this.key) ?? "";
  save = (value: string) => {
    saveStoredItem(this.key, value);
  };

  remove = () => {
    removeStoredItem(this.key);
  };
}

export { getStoredItem, saveStoredItem, removeStoredItem };
export default StorageItem;
